let service = function (
	$rootScope, 
	$ionicPopup,
	Http, 
	$state,
	Session, 
	Filter,
	$filter,
	growl,
	_
) {
	"ngInject";

	let service = this;

	var list = Session.get('compareList') ? Session.get('compareList') : [];

	this.log = (data) => Http.post('/v1/compare/log', 'POST', data);
	this.get = (data) => Http.get('/v1/compare', false, data);
	this.list = () => list;
	this.category = () => (list.length?parseInt(list[0].category_id):false);
	this.add = function(product) {
		if(_.find(list, (x) => x.icecat.id === product.icecat.id)) {
			this.remove(product.icecat.id);
		} else if(list.length < 3) {
			growl.success($filter('translate')('growl_compare_product_added'));
			list.push(product);
			Session.set('compareList', angular.copy(list));
			$rootScope.$broadcast('COMPARE_LIST_CHANGED', list, "add");
		} else {
			$ionicPopup.alert({
				title: $filter('ucfirst')($filter('translate')('compare_alert_title')),
				subTitle: $filter('ucfirst')($filter('translate')('compare_alert_content')),
				buttons: [
					{
						text: $filter('ucfirst')($filter('translate')('compare_clear')),
						type: 'button-dark',
						onTap: (e) => {
							service.clear();
						}
					},
					{
						type: 'button-assertive',
						text: $filter('ucfirst')($filter('translate')('compare_go')),
						onTap: (e) => {
							$state.go('tab.compare');
						}
					}
				]
			});
		}
	};
	this.remove = function(id) {
		_.remove(list, (x) => x.icecat.id === id);
		Session.set('compareList', angular.copy(list));
		$rootScope.$broadcast('COMPARE_LIST_CHANGED', list, "remove");
	};
	this.string = () => {
		var arr = _.map(list,(product) => product.icecat.id);
		return arr.join(',');
	};
	this.clear = function() {
		Session.remove('compareList');
		list = [];
		$rootScope.$broadcast('COMPARE_LIST_CLEARED');
	};
	this.inList = function(id) {
		return _.find(list,(x) => x.icecat.id == id);
	};
	this.hide = () => {
		$rootScope.$broadcast('HIDE_COMPARE');
	};
	this.assess = function(products) {
		angular.forEach(products, function(product, idx) {
			product.differences = [];
			product.similarities = [];
			
			angular.forEach(product.icecat.definitions, function(definition) {
				var similar = 0;
				angular.forEach(products, function(p, i) {
					if(i !== idx) {
						angular.forEach(p.definitions, function(d) {
							if(definition.id === d.id) {
								similar++;
							}
						});
					}
				});
				product[(similar < 2 ? 'differences' : 'similarities')].push(definition);
			});
		});
		
		return products;
	};
}

export default service;


// WEBPACK FOOTER //
// ./app/components/compare/compare.service.js